import { useNavigate } from 'react-router';
import { RectangleListIcon } from "../../../icons"

const Menus = (id: number) => {
  const navigate = useNavigate();
  const showActions = () => navigate('/restaurants/' + id + '/menus');
  return (
    <button
      onClick={showActions}
      className="flex items-center justify-center gap-2 rounded-full border border-gray-300 bg-white px-4 py-3 text-sm font-medium text-gray-700 shadow-theme-xs hover:bg-gray-50 hover:text-gray-800 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-white/[0.03] dark:hover:text-gray-200 lg:inline-flex lg:w-auto"
    >
      <RectangleListIcon width={20} height={20}/>
      Menus
    </button>
  );
}

export default Menus;
